import App, { themeContext } from "./App";
export { themeContext };
export default App;
